export default __webpack_public_path__ + "static/media/quote.2420c4a6.svg";